import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { enviroments } from 'utils/constants';

export const alertsServiceApi = createApi({
  reducerPath: 'alertServiceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: enviroments.endPoint,
    prepareHeaders: (headers, { getState, endpoint }) => {
      headers.set('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem('userAccountInformation') || '{}').bearerToken);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    GetAlerts: builder.query<any, any>({
      query: (params) => `alert/?locale=${params['language']}`,
    }),
    GetAlertsById: builder.query<any, any>({
      query: (params) => `alert/${params['id']}/?locale=${params['language']}`,
    }),
    GetMessagesPriority: builder.query<any, void>({
      query: (locale) => `messages/priority?locale=${locale}`,
    }),
  }),
});

export const { useLazyGetAlertsByIdQuery, useLazyGetAlertsQuery, useLazyGetMessagesPriorityQuery } = alertsServiceApi;
